import { useMemo } from "react";
import * as React from "react";
import { StyleSheet } from "react-native";

import { FormikStaticTextField, useTheme } from "@smartrent/ui";

import { useFormikFieldsHook } from "@/pages/hub-refurbish/hooks/useFormikFieldsHook";
import {
  HubRefurbishFormikFieldLabels,
  HubRefurbishFormikFieldNames,
  HubRefurbishReactQueryKeys,
} from "@/types/HubRefurbishProps";

import { ConnectionStatus } from "@/utils/zipato";

import { useHubRefurbishContext } from "@/pages/hub-refurbish/HubRefurbishContext";

export const RedisStatsFormikFieldError: React.VFC = () => {
  const { colors } = useTheme();
  const { getHubs } = useHubRefurbishContext();

  const errorAndUnknownHubs = useMemo(
    () =>
      getHubs(
        (hub) => hub?.isError || hub?.status === ConnectionStatus.Unknown
      ),
    [getHubs]
  );

  // ERROR
  const { onClearCallback, containerStyle, labelStyle, disabled } =
    useFormikFieldsHook({
      required: false,
      name: HubRefurbishFormikFieldNames.Error,
      queryKey: HubRefurbishReactQueryKeys.RedisStats,
      value: errorAndUnknownHubs,
    });

  return (
    <FormikStaticTextField
      style={styles.root}
      containerStyle={{
        ...containerStyle,
        ...{ backgroundColor: colors.warningMutedBackground },
      }}
      labelStyle={{
        ...labelStyle,
        ...{ color: colors.warningText },
      }}
      name={HubRefurbishFormikFieldNames.Error}
      label={HubRefurbishFormikFieldLabels.Error}
      onPress={() => null}
      transformValue={(value) => value?.length} // display count only
      onClear={onClearCallback}
      disabled={disabled}
    />
  );
};

const styles = StyleSheet.create({
  root: { maxWidth: 175 },
});
